import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "flex-v-center mb20"
};
var _hoisted_2 = {
  class: "ta-r w100 mr10"
};
import { ref, watch } from 'vue';
import { ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';
import { asyncComputed } from '@vueuse/core';
import { getAuthListConfig } from '../commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  props: ['options', 'options2', 'options3', 'options4'],
  emits: ['limitChange'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var route = useRoute();
    var use_senior = ref(false);
    var selectLimit = ref(0);
    var member_value = ref([]);
    var content_value = ref('MODIFY'); // 权限类型列表

    var contents = asyncComputed(function () {
      return getAuthListConfig({
        appKey: route.params.project,
        categoryKey: props.options.value
      });
    }); // emits
    // methods
    // 子组件回调给父组件当前子组件信息

    var handleSelectContents = function handleSelectContents() {
      emits('limitChange', props.options.value, member_value.value, content_value.value);
    }; // select-group 的 所有人和个人 的反选


    var handleSelect = function handleSelect() {
      var _member_value$value, _member_value$value2;

      if (member_value.value[((_member_value$value = member_value.value) === null || _member_value$value === void 0 ? void 0 : _member_value$value.length) - 1] === 'all') {
        if (member_value.value.length === 1) {
          member_value.value = ['all'];
          selectLimit.value = 1;
          handleSelectContents();
        } else {
          ElMessageBox.confirm('确定选择 所有人 后会取消之前的所有对象，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            member_value.value = ['all'];
            selectLimit.value = 1;
            handleSelectContents();
          }).catch(function () {
            member_value.value.pop();
            handleSelectContents();
          });
        }
      } else if (member_value.value[((_member_value$value2 = member_value.value) === null || _member_value$value2 === void 0 ? void 0 : _member_value$value2.length) - 1] === 'self') {
        if (member_value.value.length === 1) {
          member_value.value = ['self'];
          selectLimit.value = 1;
          handleSelectContents();
        } else {
          ElMessageBox.confirm('确定选择 仅自己 后会取消之前的所有对象，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            member_value.value = ['self'];
            selectLimit.value = 1;
            handleSelectContents();
          }).catch(function () {
            member_value.value.pop();
            handleSelectContents();
          });
        }
      } else {
        selectLimit.value = 0;
        handleSelectContents();
      }
    }; // 监听 父组件回调的数据，回显select框内容和content 框状态


    watch(function () {
      return props.options4;
    }, function () {
      var _props$options, _props$options2;

      member_value.value = (_props$options = props.options4) === null || _props$options === void 0 ? void 0 : _props$options.selectData;
      content_value.value = (_props$options2 = props.options4) === null || _props$options2 === void 0 ? void 0 : _props$options2.dataAssetAction;

      if (member_value.value && content_value.value) {
        handleSelect();
      }
    });
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_option_group = _resolveComponent("el-option-group");

      var _component_el_select = _resolveComponent("el-select");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("label", _hoisted_2, _toDisplayString(__props.options.label), 1), _createVNode(_component_el_select, {
        modelValue: member_value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return member_value.value = $event;
        }),
        filterable: "",
        multiple: "",
        clearable: "",
        placeholder: "请选择",
        style: {
          "min-width": "380px",
          "margin-right": "10px"
        },
        disabled: use_senior.value,
        "multiple-limit": selectLimit.value,
        onChange: handleSelect
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_option_group, {
            label: "群体"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_option, {
                label: "所有人",
                value: "all"
              }), _createVNode(_component_el_option, {
                label: "仅自己",
                value: "self"
              })];
            }),
            _: 1
          }), _createVNode(_component_el_option_group, {
            label: "角色组"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options2, function (item, index) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }), _createVNode(_component_el_option_group, {
            label: "单个用户"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options3, function (item, index) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.name,
                  value: item.login_name
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue", "disabled", "multiple-limit"]), _createVNode(_component_el_select, {
        modelValue: content_value.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return content_value.value = $event;
        }),
        placeholder: "请选择",
        style: {
          "width": "100px"
        },
        disabled: use_senior.value,
        onChange: handleSelectContents
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contents), function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.key,
              label: item.desc,
              value: item.key
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue", "disabled"])]);
    };
  }
});